import { categories } from "@/mocks/categories";

export default function CategoryButtons() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl text-foreground-900">
          Explore Sugargoo Spreadsheet Categories
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          Browse our organized product database across every category. Find exactly what you&rsquo;re looking for in seconds.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.name}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer overflow-hidden"
          >
            <div className="w-full aspect-square overflow-hidden">
              <img
                src={cat.image}
                alt={`${cat.name} Sugargoo Spreadsheet category`}
                title={`${cat.name} Sugargoo Spreadsheet - Browse Curated Product Database`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-3 md:p-3.5 flex flex-col items-center text-center gap-1.5">
              <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-sm md:text-base text-foreground-500 group-hover:text-primary-600 transition-colors`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors leading-tight">
                {cat.name}
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}